import React from 'react'
// libs
import { Field } from 'redux-form'
import styled from 'styled-components'
// components
import ErrorMessage, { ErrorMessageWrapper } from 'components/UI/ErrorMessage'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
// types
import { IOption } from 'components/FormElements/Select'
import { Validators } from 'utils/validators'
import { RadioGroupProps } from '@mui/material/RadioGroup'
import { WrappedFieldProps } from 'redux-form/lib/Field'

const ReduxRadioGroupWrapper = styled(FormControl)`
  && {
    position: relative;

    label {
      height: 30px;
    }
  }
`

interface Props extends Omit<RadioGroupProps, 'ref' | 'onChange'> {
  options: IOption[]
  validate?: Validators
  handleInputBlur?: () => void
  handleInputChange?: () => void
}

const renderComponent = ({
  meta,
  input,
  options,
  handleInputBlur,
  handleInputChange,
  ...rest
}: Props & WrappedFieldProps) => {
  const { touched, error } = meta

  const onChange = (_: React.ChangeEvent<HTMLInputElement>, value: string) => {
    input.onChange(value)
  }

  return (
    <ReduxRadioGroupWrapper margin='none' fullWidth error={touched && !!error}>
      <RadioGroup name={input.name} value={input.value} onChange={onChange} {...rest}>
        {options?.map(({ label, value, labelPlacement }) => (
          <FormControlLabel
            key={value}
            value={value}
            label={label}
            control={<Radio color='primary' />}
            labelPlacement={labelPlacement || 'end'}
          />
        ))}
      </RadioGroup>
      {touched && error && (
        <ErrorMessageWrapper>
          <ErrorMessage>{error}</ErrorMessage>
        </ErrorMessageWrapper>
      )}
    </ReduxRadioGroupWrapper>
  )
}

const ReduxRadioGroup: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxRadioGroup
